import { NycbsPharmaOrderModel } from "../../../data-model/nycbsPharmaOrder";
import { NycbsPharmaOrderKeys } from "../../../enums/nycbsPharmaOrder";

export const getCorrectTextForHover = (data: NycbsPharmaOrderModel): string => {
  const comment = data?.[NycbsPharmaOrderKeys.CmmComments];
  const errorText = data?.[NycbsPharmaOrderKeys.ErrorText];

  if (comment && comment.trim() !== "" && comment.trim() !== null) {
    return comment;
  }

  if (errorText && errorText.trim() !== "" && errorText.trim() !== null) {
    return errorText;
  }

  return "";
};
